// extracted by mini-css-extract-plugin
module.exports = {"container":"pagination_container__Q_r7q","page-size":"pagination_page-size__QChTe","MuiOutlinedInput-root":"pagination_MuiOutlinedInput-root____MlA"};